import moment, { type Moment, type MomentInput } from 'moment';

type HierarchyDateValue = MomentInput | Moment | null | undefined;

export function getDefaultHierarchyStartDate(): string {
	return moment('2020-01-01').startOf('day').toISOString();
}

export function getDefaultHierarchyEndDate(): string {
	return moment().endOf('day').toISOString();
}

export function getHierarchyStartDateOrDefault(startDate?: string | null): string {
	return startDate || getDefaultHierarchyStartDate();
}

export function getHierarchyEndDateOrToday(endDate?: string | null): string {
	return endDate || getDefaultHierarchyEndDate();
}

export function getHierarchyStartDateMoment(startDate?: string | null): Moment {
	return startDate ? moment(startDate) : moment('2020-01-01');
}

export function getHierarchyEndDateMoment(endDate?: string | null): Moment {
	return endDate ? moment(endDate) : moment();
}

export function normalizeHierarchyStartDate(startDate: HierarchyDateValue): string {
	if (!startDate) {
		return getDefaultHierarchyStartDate();
	}

	return moment.isMoment(startDate) ? startDate.clone().startOf('day').toISOString() : String(startDate);
}

export function normalizeHierarchyEndDate(endDate: HierarchyDateValue): string {
	if (!endDate) {
		return getDefaultHierarchyEndDate();
	}

	return moment.isMoment(endDate) ? endDate.clone().endOf('day').toISOString() : String(endDate);
}
